module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAoklEQVQoU2Pk93+/n5GBQfc3A2PE140CexhwAEaBgPf/QXL/GRh+MTH8T3i/QWg5NrVwhVDJfwz/GUo+bBTsR1eMrhAs/////+6PGwXLGRgYwbaBAFaFEKn/Sz48vpfEcNbkNwGFIPMYd71n+xXMsFrsCx4ToXb+Zzj75/tPL8IKISFyhYoKibGa8f//Xe/Z/hDyDBHBQ0yAE45CgomC2GQGAGTidfPS+hBBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_arrow2.png
// module id = +72w
// module chunks = 1